import createMuiTheme from '../../../common/js/theme'

const greenLight = '#99f2e4'
const greyLight = '#aeb4b0'
const coolBlue = '#0076cf'
const coolBlueDark = '#004b9d'

const theme = createMuiTheme({
  colors: {
    primary: coolBlue,

    white: '#ffffff',
    blue: '#141b4d',
    blueLight: '#424279',
    blueDark: '#000026',
    green: '#33e4c9',
    greenLight,
    greenDark: '#00b19d',
    coolBlue,
    coolBlueLight: '#cce4f6',
    coolBlueDark,
    grey: '#7f8481',
    greyLight,
    greyDark: '#535755',
    greenAlt: '#1bd114',
    validateFail: '#e40028',
    validateOk: '#1bd114',
  },
  primaryButtonColor: coolBlue,
  buttonHoverBackground: coolBlueDark,
  modal: {
    buttonBarColor: greenLight,
  },
})

export default theme
